import MediaFile, { MediaFileId } from '@/general/models/MediaFile';

export default class InvoiceFile extends MediaFile {
  reference = '';

  static withId(id: MediaFileId): InvoiceFile {
    return this.withData({ id });
  }

  static withData(data: Partial<InvoiceFile>): InvoiceFile {
    return Object.assign(new InvoiceFile(), data);
  }
}